import { ForecastData } from 'src/Libs/system-data-handler'
import { HistoryChartData } from 'src/Libs/system-data-handler/utils/chartFunctions'

/* In order to fill the gap in the chart we need to extend the last non-forecast history item, this is replicated from the updateChartData function firstForecast section */
export const extendHistoryItem = (data: HistoryChartData): Partial<ForecastData> => {
  const extendedHistoryItem: Partial<ForecastData> = { forecast: true, Deration: data.Deration }

  Object.keys(data).forEach(key => {
    if (key !== 'ts' && key !== 'ForecastPower') {
      extendedHistoryItem[`f-${key}`] = data[key]
    }
  })

  return extendedHistoryItem
}
